<ion-header>

</ion-header>
<ion-content>

    <img class="fullscreen" src="{{ imageUrl }}" />

    <ion-fab bottom right>
        <button ion-fab (click)="onShare()">
            <ion-icon name="share"></ion-icon>
        </button>
    </ion-fab>
</ion-content>